export default __webpack_public_path__ + "static/media/namecheap.6e6b8727.svg";